import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "filename", "removeFlag", "removeButton"];
  static values = {
    filename: String,
    filePath: String,
  };

  connect() {
    // 初期表示時、一時ファイルが存在する場合はファイル名を表示
    if (this.hasFilenameValue && this.filenameValue) {
      this.showFile(this.filenameValue);
      // ファイル名をクリック可能なリンクにする
      if (this.hasFilePathValue && this.filePathValue) {
        const link = document.createElement("a");
        link.href = this.filePathValue;
        link.textContent = this.filenameValue;
        link.target = "_blank";
        link.className = "text-decoration-underline";
        this.filenameTarget.innerHTML = ""; // 既存のテキストをクリア
        this.filenameTarget.appendChild(link);
      }
    }
  }

  change(event) {
    const file = event.target.files[0];
    if (file) {
      this.showFile(file.name);
      // リンクを通常のテキストに戻す
      this.filenameTarget.textContent = file.name;
      // 一時ファイル情報をクリア（新しいファイルが選択されたため）
      this.clearTempFileInfo();
    } else {
      // ファイル選択がキャンセルされた場合
      this.clearFile();
    }
  }

  showFile(filename) {
    this.filenameTarget.textContent = filename;
    this.removeButtonTarget.classList.remove("d-none");
  }

  remove(event) {
    event.preventDefault();
    this.clearFile();
  }

  clearFile() {
    this.inputTarget.value = "";
    this.filenameTarget.textContent = "";
    this.removeFlagTarget.value = "1";
    this.removeButtonTarget.classList.add("d-none");
    this.clearTempFileInfo();
  }

  clearTempFileInfo() {
    // 一時ファイル情報をクリア
    const tempFilePathInput = this.element.querySelector(
      'input[name$="[temp_file_path]"]'
    );
    const tempFileDataInput = this.element.querySelector(
      'input[name$="[temp_file_data]"]'
    );

    if (tempFilePathInput) tempFilePathInput.remove();
    if (tempFileDataInput) tempFileDataInput.remove();
  }
}
